import {
  AmbientLightPropsDto,
  DirectionalLightPropsDto,
  LightName,
  LightPropsDto,
  PointLightPropsDto,
  SpotLightPropsDto,
} from "@/types/vault-object-filter-types";
import { SpotLight } from "@react-three/drei";
import {
  GAIA_AMBIENT_LIGHT_COLOR,
  GAIA_AMBIENT_LIGHT_INTENSITY,
  GAIA_DIRECTIONAL_LIGHT_INTENSITY,
} from "@/utils/gaia-constants";
import React from "react";
import useVaultStore from "@/stores/zustand/vault/useVaultStore";

export const shadowBias = -0.0001;
export const shadowNormalBias = 0.02;

export const Lights = ({ lights }: { lights: LightPropsDto[] }) => {
  const currentPage = useVaultStore((state) => state.currentPage);

  if (lights.length === 0) {
    return (
      <>
        <ambientLight
          key="default-ambient"
          args={[GAIA_AMBIENT_LIGHT_COLOR, GAIA_AMBIENT_LIGHT_INTENSITY]}
        />
        <directionalLight
          key="default-directional"
          args={[GAIA_AMBIENT_LIGHT_COLOR, GAIA_DIRECTIONAL_LIGHT_INTENSITY]}
          position={[4, 3, 2]}
          castShadow
          shadow-bias={shadowBias}
          shadow-normalBias={shadowNormalBias}
          shadow-camera-left={-8}
          shadow-camera-top={8}
          shadow-camera-right={8}
          shadow-camera-bottom={-8}
          shadow-camera-near={0.1}
          shadow-camera-far={20}
          shadow-mapSize-width={4096}
          shadow-mapSize-height={4096}
          name={"DefaultShadowLight"}
        />
      </>
    );
  } else {
    return (
      <>
        {lights.map((light) => {
          const { type, ...props } = light;

          switch (type) {
            case LightName.AmbientLight:
              return (
                <ambientLight
                  key={light.name}
                  {...(props as AmbientLightPropsDto)}
                />
              );
            case LightName.DirectionalLight: {
              const { shadow, position, ...rest } =
                props as DirectionalLightPropsDto;

              return (
                <directionalLight
                  key={light.name}
                  position={
                    position ? [position.x, position.y, position.z] : undefined
                  }
                  // target={target}
                  {...shadow}
                  shadow-bias={shadowBias}
                  shadow-normalBias={shadowNormalBias}
                  {...rest}
                  castShadow={props.castShadow !== false}
                  shadow-mapSize-width={4096}
                  shadow-mapSize-height={4096}
                />
              );
            }
            case LightName.PointLight: {
              const { shadow, position, ...rest } = props as PointLightPropsDto;

              return (
                <pointLight
                  key={light.name}
                  position={
                    position ? [position.x, position.y, position.z] : undefined
                  }
                  {...shadow}
                  shadow-bias={shadowBias}
                  shadow-normalBias={shadowNormalBias}
                  {...rest}
                  castShadow={props.castShadow !== false}
                  shadow-mapSize-width={4096}
                  shadow-mapSize-height={4096}
                />
              );
            }
            case LightName.SpotLight: {
              const { shadow, position, intensity, power, ...rest } =
                props as SpotLightPropsDto;

              // if (currentPage.endsWith("thumbnail")) {
              return (
                <React.Fragment key={light.name}>
                  <spotLight
                    intensity={intensity ? intensity * 80 : undefined}
                    power={power ? power * 80 : undefined}
                    position={
                      position
                        ? [position.x, position.y, position.z]
                        : undefined
                    }
                    {...shadow}
                    shadow-bias={shadowBias}
                    shadow-normalBias={shadowNormalBias}
                    {...rest}
                    castShadow={props.castShadow !== false}
                    shadow-mapSize-width={4096}
                    shadow-mapSize-height={4096}
                  />
                  {!currentPage.endsWith("thumbnail") && (
                    <SpotLight
                      opacity={0.1}
                      radiusTop={0}
                      position={
                        position
                          ? [position.x, position.y, position.z]
                          : undefined
                      }
                      {...rest}
                    />
                  )}
                </React.Fragment>
              );
              // } else {
              //   return (
              //     <SpotLight
              //       key={light.name}
              //       opacity={0.25}
              //       position={
              //         position
              //           ? [position.x, position.y, position.z]
              //           : undefined
              //       }
              //       {...shadow}
              //       shadow-bias={shadowBias}
              //       shadow-normalBias={shadowNormalBias}
              //       {...rest}
              //       castShadow={props.castShadow !== false}
              //       shadow-mapSize-width={4096}
              //       shadow-mapSize-height={4096}
              //     />
              //   );
              // }
            }
          }
        })}
      </>
    );
  }
};
